/**
 * @description ルーティング ガード。現在、すべてのモードとインテリジェンス モードの 2 つのモードがあります。
 */
// import axios from 'axios'
import router from '@/router'
import store from '@/store'
import VabProgress from 'nprogress'
import 'nprogress/nprogress.css'
import getPageTitle from '@/utils/pageTitle'
import { toLoginRoute } from '@/utils/routes'
import Cookies from 'js-cookie'
import {
  authentication,
  routesWhiteList,
  authMode,
  publicPath,
  authUrl,
} from '@/config'

VabProgress.configure({
  easing: 'ease',
  speed: 500,
  trickleSpeed: 200,
  showSpinner: false,
})

const redirectUrl = (next, to) => {
  if (authMode != 'normal') {
    if (!sessionStorage.getItem('redirectUri')) {
      sessionStorage.setItem('redirectUri', to.fullPath)
    }
    // https://tra.works.tomooni.com/works-partner/oauth2/authorization/tomooni
    window.location.href = `${authUrl}${publicPath}works-partner/oauth2/authorization/tomooni`
  } else {
    next(toLoginRoute(to.fullPath))
  }
}

router.beforeEach(async (to, from, next) => {
  const { showProgressBar } = store.getters['settings/theme']
  if (showProgressBar) VabProgress.start()

  let hasToken = null
  if (authMode != 'normal') {
    hasToken = Cookies.get('SESSION')
  } else {
    hasToken = store.getters['user/token']
  }
  if (hasToken) {
    if (store.getters['routes/routes'].length) {
      if (to.path === '/login') {
        next({ path: '/' })
        if (showProgressBar) VabProgress.done()
      } else {
        next()
      }
    } else {
      try {
        await store.dispatch('user/getUserInfo')
        await store.dispatch('routes/setRoutes', authentication)
        let redirectUri = sessionStorage.getItem('redirectUri')
        if (redirectUri) {
          if (redirectUri.indexOf('mobile') > 0) {
            window.location.href = `${authUrl}/mobile/`
          } else {
            next({ path: redirectUri, replace: true })
          }
          sessionStorage.removeItem('redirectUri')
        } else {
          // 判断移动端
          if (/Mobi|Android|iPhone/i.test(navigator.userAgent) && authUrl) {
            window.location.href = `${authUrl}/mobile/`
          } else {
            next({ ...to, replace: true })
          }
        }
      } catch (err) {
        await store.dispatch('user/resetAll')
        //redirectUrl(next, to)
      }
    }
  } else {
    if (routesWhiteList.includes(to.path)) {
      next()
    } else {
      redirectUrl(next, to)
    }
  }
})
router.afterEach((to) => {
  document.title = getPageTitle(to.meta.title)
  if (VabProgress.status) VabProgress.done()
})
